export default __webpack_public_path__ + "static/media/img.bf37d14a.jpg";